import { FiatCurrencyCode, PaymentType } from 'enums';

// Trader banks charge different fees per bank for KGS transfers, so the merchant wants the bank
// visible before the phone number for this specific scenario only; see SPAY-5027.
export const isPhoneNumberKgs = (
  paymentType: PaymentType | undefined,
  fiatCurrency: string | undefined,
): boolean =>
  paymentType === PaymentType.PhoneNumber &&
  fiatCurrency === FiatCurrencyCode.KGS;
